import React from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import {ROUTES} from "../../../../../routes";
import GroheCartStickyFooter from "../groheCartStickyFooter";
import GroheCartShippingDropdown from "./groheCartShippingDropdown";
import GroheCartPaymentDropdown from "./groheCartPaymentDropdown";
import GroheCartBillingDropdown from "./groheCartBillingDropdown";
import GroheCartBackButton from "../groheCartBackButton";


const GroheCartBilling = (props) => {

  const {isMobile, history, cardInfo, userInfo, shippingAddress, userIsLoggedIn, fabricatorSettings,
    isPhoneNumberValidated} = props;

  const disabled = Object.keys(cardInfo).some(key => !cardInfo[key])
    || !((userInfo.address1 || userInfo.postal) || (shippingAddress.address1 || shippingAddress.postal));

  const backButtonClick = () => {
    if (userIsLoggedIn) {
      history.push(ROUTES.cart);
    } else {
      history.push(isMobile ? ROUTES.cartRegister : ROUTES.cartLogin)
    }
  }

  const nextButtonClick = () => {
    if (userIsLoggedIn) {
      if (fabricatorSettings.twoFA && !isPhoneNumberValidated) {
        history.push(ROUTES.cartTwoFA);
      } else {
        history.push(ROUTES.cartConfirm);
      }
    } else {
      history.push(isMobile ? ROUTES.cartRegister : ROUTES.cartLogin)
    }
  };

  const stickyFooterButtons = [
    {
      translate: "buttons.back",
      classes: "look-button--secondary",
      onClick: () => {
        history.push(ROUTES.cart);
      }
    },
    {
      translate: "buttons.next",
      classes: "look-button--blue gc-sticky__button--60",
      onClick: nextButtonClick,
      disabled
    },
  ];

  return (
    <div className="gc">
      <div className="gc-body">
        <GroheCartShippingDropdown/>
        <div className="gc-form gc-form--register">
          <GroheCartPaymentDropdown/>
        </div>
        <div className="gc-form gc-form--register gc-form--no-top">
          <GroheCartBillingDropdown/>
          {isMobile ? null : (
            <div className="gc-form__submit">
              <div className="gc-form__submit-left"/>
              <div className="gc-form__submit-right">
                <GroheCartBackButton backButtonClick={backButtonClick}/>
                <Button className="look-button look-button--blue look-button--big look-button--large nowrap"
                        disabled={disabled}
                        onClick={nextButtonClick}>
                  <FormattedMessage id="buttons.next"/>
                </Button>
              </div>
            </div>
          )}
        </div>
        {isMobile ? <div className="gc-spacer"/> : null}
      </div>
      {isMobile ? <GroheCartStickyFooter stickyFooterButtons={stickyFooterButtons}/> : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {cardInfo, shippingAddress} = store.paymentState;
  const {userInfo, userIsLoggedIn, isPhoneNumberValidated} = store.userState;
  const {settings} = store.fabricatorState;

  return {
    isMobile,
    cardInfo,
    shippingAddress,
    userInfo,
    userIsLoggedIn,
    isPhoneNumberValidated,
    fabricatorSettings: settings,
  };
};

const mapDispatchToProps = {

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroheCartBilling))
